import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchEvstatus } from './evstatusAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: {},
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};


// Async thunk to fetch data with filters
export const fetchEvstatusDataWithFilters = createAsyncThunk(
  'evstatus/fetchEvstatusDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchEvstatus({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const EvstatusSlice = createSlice({
  name: 'evstatus',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvstatusDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchEvstatusDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data[action.payload?.results?.[0]?.vin || 0] = action.payload.results?.[0] || { currentSoc: 0, state: '', vin: '' }; // Store the fetched data
      })
      .addCase(fetchEvstatusDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectEvstatusData = (state) => state.evstatus.data;
export const selectEvstatusStatus = (state) => state.evstatus.status;
export const selectEvstatusError = (state) => state.evstatus.error;

export default EvstatusSlice.reducer;
